export default function toggle() {
  $('.js-toggle').on('click', function (e) {
    $('.js-toggle').not(this).removeClass('active');
    e.stopPropagation();
    $(this).toggleClass('active');
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.js-toggle').length) {
      $('.js-toggle').removeClass('active');
    }
  });

  $('tr').on('click', '[type=checkbox]', function (e) {
    e.stopPropagation();
  });

  $('.js-collapse-toggle').on('click', function () {
    $('.js-collapse').toggleClass('active');

    if ($('.js-collapse').hasClass('active')) {
      setTimeout(function () {
        $('.js-textarea').focus();
      }, 300);
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/toggle.js